import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";

const AgentViewModal = ({ show, onHide, agent }) => {
  const t = useTranslation("agent_view");
  if (!agent) return null;

  const permissions = [
    { key: "payin", enabled: !!agent?.configuration?.payin },
    { key: "payout", enabled: !!agent?.configuration?.payout },
    { key: "withdraw", enabled: !!agent?.configuration?.withdraw },
    { key: "deposit", enabled: !!agent?.configuration?.deposit },
    { key: "payin_wallet", enabled: !!agent?.configuration?.payin_wallet },
    { key: "payout_wallet", enabled: !!agent?.configuration?.payout_wallet },
  ];

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <div className="text-muted small">{t("name")}</div>
          <div className="fw-semibold">{agent?.name || "-"}</div>
        </div>
        <div className="mb-3">
          <div className="text-muted small">{t("email")}</div>
          <div className="fw-semibold">{agent?.email || "-"}</div>
        </div>
        <div className="mb-3">
          <div className="text-muted small">{t("permissions")}</div>
          <div className="d-flex flex-wrap gap-2 mt-1">
            {permissions.map((item) => (
              <span
                key={item.key}
                className={`badge ${
                  item.enabled ? "bg-success" : "bg-secondary"
                }`}
              >
                {t(`permission_labels.${item.key}`)}
              </span>
            ))}
          </div>
        </div>
        <div className="d-flex flex-wrap gap-3">
          <div>
            <div className="text-muted small">{t("created_at")}</div>
            <div className="fw-semibold">{agent?.created_at || "-"}</div>
          </div>
          <div>
            <div className="text-muted small">{t("updated_at")}</div>
            <div className="fw-semibold">{agent?.updated_at || "-"}</div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AgentViewModal;
